/* eslint-disable camelcase */
import type { Currency } from '@backmarket/http-api'
import type {
  Granularity,
  Product,
  Products,
} from '@backmarket/nuxt-layer-recommendation/models/product'

import type { AlgoliaPayload, AlgoliaProductHit, Variant } from './types'

export function mapSingleAlgoliaHitToProduct(
  algoliaHit: AlgoliaProductHit,
  productGranularity?: Granularity,
): Product {
  const {
    id,
    brand,
    brand_clean,
    category_3,
    currency,
    backbox_grade_label,
    backbox_grade_value,
    price,
    stockRaw,
    title_model,
    image1,
    link_grade_v2,
    link_master_pp,
    warranty,
    reviewRating,
    sub_title_elements,
    listingID,
    listing_id,
    model,
    model_clean,
    merchant_id,
    referencePrice,
    variant_fields,
    special_offer_type,
    backmarketID,
    deals,
    marketing_tags,
  } = algoliaHit
  const description = sub_title_elements?.join(' - ') || ''

  const specEntries = Object.entries(variant_fields).map(
    ([key, specification]) => {
      const cleanSpec = specification.filter((item: Variant) => item.name)

      return [key, cleanSpec]
    },
  )
  const specifications = Object.fromEntries(specEntries)

  return {
    id,
    title: title_model,
    description,
    listingId: `${listingID}`,
    listingPublicId: listing_id,
    model,
    modelClean: model_clean,
    brand,
    brandClean: brand_clean,
    sellerId: merchant_id?.toString(),
    category: category_3,
    grade: {
      name: backbox_grade_label,
      value: backbox_grade_value,
    },
    productId: String(backmarketID),
    productPageLink:
      productGranularity === 'parent'
        ? (link_master_pp ?? link_grade_v2)
        : link_grade_v2,
    priceNew: referencePrice,
    price: {
      amount: price.toString(),
      currency: currency as Currency,
    },
    reviewRating,
    availableStock: stockRaw,
    warrantyDuration: warranty,
    image: image1,
    specifications,
    specialOfferType: special_offer_type ?? 0,
    deal: deals?.[0],
    marketingTags: marketing_tags,
  }
}

export function mapAlgoliaResultsToProducts(
  algoliaPayload: AlgoliaPayload,
  productGranularity?: Granularity,
): Products {
  return algoliaPayload.results.flatMap((result) =>
    result.hits.map((hit) =>
      mapSingleAlgoliaHitToProduct(hit, productGranularity),
    ),
  )
}
